import axios from "axios";

axios.defaults.withCredentials = true;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getMe = () => axios.get(`${API}/auth/me`).then((r) => r.data);
export const createSession = (session_id) =>
  axios.post(`${API}/auth/session`, { session_id, client_id: getClientId() }).then((r) => r.data);
export const logoutApi = () => axios.post(`${API}/auth/logout`);
export const getLatestSession = () => axios.get(`${API}/chat/latest`, { params: { client_id: getClientId() } }).then((r) => r.data);

export const getCategories = () => axios.get(`${API}/categories`).then((r) => r.data);
export const getFaqs = (params) => axios.get(`${API}/faqs`, { params }).then((r) => r.data);
export const getFaq = (slug) => axios.get(`${API}/faqs/${slug}`).then((r) => r.data);
export const voteFaq = (slug, helpful) => axios.post(`${API}/faqs/${slug}/vote`, { helpful }).then((r) => r.data);
export const getChatHistory = (sid) => axios.get(`${API}/chat/${sid}/messages`, { params: { client_id: getClientId() } }).then((r) => r.data);

export const getClientId = () => {
  let id = localStorage.getItem("gh-client-id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("gh-client-id", id);
  }
  return id;
};
export const getProStatus = () => axios.get(`${API}/pro/status/${getClientId()}`).then((r) => r.data);
export const startCheckout = () =>
  axios
    .post(`${API}/payments/checkout`, { lookup_key: "gearhead_pro_lifetime", origin_url: window.location.origin })
    .then((r) => r.data);
export const getPaymentStatus = (sid) => axios.get(`${API}/payments/status/${sid}`).then((r) => r.data);

export class LimitReachedError extends Error {}

export const uploadPhoto = (blob) => {
  const fd = new FormData();
  fd.append("file", blob, "photo.jpg");
  return axios.post(`${API}/chat/photo`, fd).then((r) => r.data);
};
export const photoUrl = (id) => `${API}/chat/images/${id}`;

export async function streamChat(sessionId, message, onDelta, model = "claude", imageId = null) {
  const res = await fetch(`${API}/chat/stream`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, client_id: getClientId(), message, model, image_id: imageId }),
  });
  if (res.status === 402) throw new LimitReachedError();
  if (!res.ok) throw new Error("Chat failed");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const data = p.replace(/^data: /, "");
      if (data === "[DONE]") return;
      const obj = JSON.parse(data);
      if (obj.error) throw new Error(obj.error);
      onDelta(obj.delta);
    }
  }
}
